import { render, staticRenderFns } from "./APIUserConfiguration.vue?vue&type=template&id=625a153e&scoped=true&"
import script from "./APIUserConfiguration.vue?vue&type=script&lang=js&"
export * from "./APIUserConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./APIUserConfiguration.vue?vue&type=style&index=0&id=625a153e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625a153e",
  null
  
)

export default component.exports